
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import SvgIcon from "@jamescoyle/vue-icon";
import { TranslateResult } from "vue-i18n";

@Component({
  components: { SvgIcon },
})
export default class ResponsiveBtn extends Vue {

  @Prop({default: ""})
  public label: string|TranslateResult;

  @Prop({default: false})
  public disabled: boolean;

  @Prop({default: ""})
  public icon: string;

  @Prop({default: undefined})
  public color: string|undefined;

  @Getter private isMobile: boolean;
}
